// extracted by mini-css-extract-plugin
export default {"modal":"MainModal_modal__EEqOB","modalContent":"MainModal_modalContent__EqgLH","active":"MainModal_active__tqJx1"};